import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {ContractData} from "./contract.data";
import FileSaver from "file-saver";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

export class SignerRequest {
    signer: string;
}

export class SignerResponse {
    url: string;
}

@Injectable()
export class ContractService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getContract(venueId: string): Promise<ContractData> {
        return firstValueFrom(this.http.get<ContractData>("/fonzie/customer-instance-venue/" + venueId + "/contract", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async createContract(venueId: string): Promise<ContractData> {
        return firstValueFrom(this.http.post<ContractData>("/fonzie/customer-instance-venue/" + venueId + "/contract", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async resetContract(venueId: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/resetContract", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getCustomerSignerLink(venueId: string): Promise<SignerResponse> {
        return this.getSignerLink(venueId, "CUSTOMER");
    }

    async getSalesRepSignerLink(venueId: string): Promise<SignerResponse> {
        return this.getSignerLink(venueId, "REP");
    }

    async getDirectorSignerLink(venueId: string): Promise<SignerResponse> {
        return this.getSignerLink(venueId, "DIRECTOR");
    }

    async getSignerLink(venueId: string, signer: string): Promise<SignerResponse> {
        const req: SignerRequest = new SignerRequest();
        req.signer = signer;
        return firstValueFrom(this.http.post<SignerResponse>("/fonzie/customer-instance-venue/" + venueId + "/contractURL", req, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async downloadContract(venueId: string): Promise<void> {
        const data = await firstValueFrom(this.http.post("/fonzie/customer-instance-venue/" + venueId + "/contractDownload", {}, {headers: this.auth.getHttpHeaderOptions(), responseType: "blob"}));
        FileSaver.saveAs(data, "contract-" + venueId + ".pdf");
    }

    async uploadContract(venueId: string, file: File): Promise<void> {
        const formData: FormData = new FormData();
        formData.append("uploadedFileName", file);
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/uploadContract", formData, {headers: this.auth.getHttpHeaderOptionsForFile()}));
    }
}
